module.exports = __webpack_public_path__ + "static/media/usb_cellular_step_2@2x.dac0d4a1.png";